import { createFileRoute } from '@tanstack/react-router'
import { ApiDocsPage } from '../features/api-docs/ApiDocsPage'

export const Route = createFileRoute('/_auth/api-docs')({
  component: ApiDocsPage,
})
